import { render, staticRenderFns } from "./phvideos.vue?vue&type=template&id=695bfe3e"
import script from "./phvideos.vue?vue&type=script&lang=js"
export * from "./phvideos.vue?vue&type=script&lang=js"
import style0 from "./phvideos.vue?vue&type=style&index=0&id=695bfe3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports